import type { ServerSummary } from "@woven/contracts";
import { EmptyState } from "../../components/StatusView";
import { ServerOverviewCard } from "./ServerOverviewCard";

export function ServersTable({ servers }: { servers: ServerSummary[] }) {
  if (servers.length === 0) {
    return (
      <EmptyState title="No servers yet" body="Create your first server above to get started." />
    );
  }
  return (
    <div className="server-card-grid" aria-label="Your Woven servers">
      {servers.map((server) => (
        <ServerOverviewCard key={server.id} server={server} />
      ))}
    </div>
  );
}
